
import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import TestimonialSection from './TestimonialKeyword';
import FaqSection from './FAQKeyword';
import FleetHighway from './FleetHighway';
import ContactShowcase from './phoneToWhatsApp';function Kiacarenceonrentinpune() {



    const cardData =
    {
        keyword: ' Kia Carens On Rent in Pune',
        heading: 'Prince Cabs: Kia Carens On Rent in Pune',
        headingDescription: 'Prince Cabs provides premium Kia Carens on Rent in Pune, perfect for family trips, corporate outings, airport transfers, and outstation journeys. Our spacious and well-maintained Kia Carens cars come equipped with modern features and comfortable seating, ensuring a safe and luxurious ride. With professional chauffeurs, flexible schedules, and transparent pricing, we make every journey convenient and hassle-free. Choose Prince Cabs’ trusted Kia Carens rental service in Pune for comfort, reliability, and affordability.',

        top: 'Top Places to Visit in Pune with Prince Cabs',

"topPlaces": [
  {
    "title": "Shaniwar Wada",
    "description": "Shaniwar Wada, built in 1732, was once the grand seat of the Peshwas of the Maratha Empire. Though much of it was destroyed in a fire, its mighty gates, expansive courtyards, and stone walls still narrate tales of Maratha valor. The evening light-and-sound show brings history to life with stories of bravery and intrigue. Visitors love exploring its gardens and ruins. Shaniwar Wada is Pune’s most iconic heritage fort and a must-visit landmark."
  },
  {
    "title": "Aga Khan Palace",
    "description": "Aga Khan Palace, constructed in 1892, is an architectural marvel with immense historical significance. During the Quit India Movement, Mahatma Gandhi, Kasturba Gandhi, and other leaders were imprisoned here. Today, it houses a museum displaying Gandhi’s personal belongings and photographs. The sprawling gardens provide a peaceful retreat. Recognized as a national monument, it symbolizes sacrifice and patriotism. It is among Pune’s most revered landmarks."
  },
  {
    "title": "Sinhagad Fort",
    "description": "Sinhagad Fort, located 30 km from Pune, is known for the historic 1670 Battle of Sinhagad. The fort’s ruins, bastions, and memorials tell stories of Maratha bravery and sacrifice. Trekkers enjoy the scenic climb, especially during monsoon when the hills are lush and misty. From the summit, panoramic views of the Sahyadris are breathtaking. Local food stalls serving pithla-bhakri add to the rustic charm. Sinhagad is both a historical and adventure hotspot."
  },
  {
    "title": "Dagdusheth Halwai Ganapati Temple",
    "description": "The Dagdusheth Halwai Ganapati Temple is Pune’s most famous spiritual landmark dedicated to Lord Ganesha. The idol is adorned with gold ornaments and attracts thousands of devotees daily. During Ganesh Chaturthi, the temple becomes the epicenter of cultural festivities. It is also renowned for charitable and community services. Its central location makes it easily accessible. Dagdusheth is both a spiritual and cultural icon of Pune."
  },
  {
    "title": "Parvati Hill",
    "description": "Parvati Hill, one of Pune’s highest points, offers panoramic views of the city skyline. At the summit lies the Parvati Temple complex dedicated to Lord Shiva and Goddess Parvati. The climb of over 100 steps is spiritually rewarding and historically significant. The Peshwa Museum nearby showcases artifacts from Maratha times. Sunrises and sunsets from here are especially mesmerizing. Parvati Hill blends devotion, history, and natural beauty."
  },
  {
    "title": "Pataleshwar Cave Temple",
    "description": "The Pataleshwar Cave Temple, dating back to the 8th century, is a rock-cut shrine dedicated to Lord Shiva. Its massive stone pillars, sanctum, and stone-carved Nandi reflect Rashtrakuta-era architecture. Despite being in the city center, the temple offers a tranquil space for meditation. Tourists admire its simplicity and historical charm. It is a hidden gem on Pune’s heritage map. Pataleshwar is perfect for history and spirituality seekers."
  },
  {
    "title": "Raja Dinkar Kelkar Museum",
    "description": "Raja Dinkar Kelkar Museum houses over 20,000 artifacts collected by Dr. Dinkar Kelkar. Its diverse collection includes musical instruments, sculptures, paintings, and everyday objects. A highlight is the recreated Mastani Mahal, showcasing Maratha heritage. The museum reflects India’s cultural richness and artistry. It is fascinating for historians, art lovers, and families. This museum is one of Pune’s most unique attractions."
  },
  {
    "title": "Osho Ashram (Koregaon Park)",
    "description": "The Osho International Meditation Resort in Koregaon Park is a world-renowned spiritual retreat. Visitors from across the globe come here for meditation, wellness programs, and yoga. Surrounded by serene gardens and modern architecture, it offers a peaceful escape from city life. The ashram promotes holistic well-being and inner transformation. Its vibrant international community adds cosmopolitan charm. Osho Ashram blends spirituality with lifestyle."
  },
  {
    "title": "Phoenix Marketcity",
    "description": "Phoenix Marketcity in Viman Nagar is Pune’s largest shopping and entertainment hub. It houses global and Indian brands, multiplex cinemas, gaming zones, and gourmet restaurants. Seasonal festivals and events make it vibrant and lively. Families enjoy shopping, dining, and leisure under one roof. It reflects the modern side of Pune. Phoenix Marketcity is the city’s ultimate lifestyle destination."
  },
  {
    "title": "Khadakwasla Dam",
    "description": "Khadakwasla Dam, about 20 km from Pune, is a favorite weekend picnic spot. It supplies water to the city and is surrounded by green hills. Families enjoy boating, roadside food, and evening walks near the reservoir. Monsoon transforms the landscape into a lush paradise. The cool breeze makes evenings refreshing. Khadakwasla is a peaceful getaway close to Pune."
  },
  {
    "title": "Mulshi Lake",
    "description": "Mulshi Lake, formed by the Mulshi Dam, is a serene outstation escape near Pune. Surrounded by Sahyadri hills and dense forests, it is ideal for camping, boating, and photography. Monsoon enhances its charm with waterfalls and misty valleys. Eco-resorts around the lake offer a perfect retreat. It is popular among couples, families, and trekkers. Mulshi balances adventure with tranquility."
  },
  {
    "title": "Chaturshringi Temple",
    "description": "Chaturshringi Temple, situated on Senapati Bapat Road, is one of Pune’s oldest shrines dedicated to Goddess Chaturshringi. Devotees climb over 100 steps to reach the sanctum. The temple is especially grand during Navratri celebrations, attracting thousands of pilgrims. Its hilltop location offers beautiful city views. The temple symbolizes faith and devotion. It is both a spiritual and cultural landmark of Pune."
  },
  {
    "title": "National War Memorial Southern Command",
    "description": "The National War Memorial in Pune honors soldiers who laid down their lives post-independence. The site showcases tanks, weapons, and war memorabilia. The museum narrates stories of India’s military history. The evening flag retreat ceremony is deeply moving. Families and students visit to instill pride and patriotism. It is a place of respect and remembrance for the armed forces."
  },
  {
    "title": "Empress Garden",
    "description": "Spread across 39 acres, Empress Garden is a lush botanical park managed by the Agri-Horticultural Society. It houses rare plants, shaded pathways, and vibrant flower nurseries. Families enjoy picnics and leisure time in its green setting. The annual flower show is a highlight for garden lovers. The garden also carries colonial-era history. Empress Garden is a refreshing oasis in Pune."
  },
  {
    "title": "Vetal Tekdi (Vetal Hill)",
    "description": "Vetal Tekdi, the highest hill in Pune, is a popular destination for trekkers, joggers, and nature lovers. The hilltop offers sweeping views of the city and surrounding areas. It is rich in biodiversity, attracting birdwatchers and fitness enthusiasts. Early mornings are peaceful with fresh air and greenery. Sunrises and sunsets from here are mesmerizing. Vetal Hill is Pune’s natural retreat and green lung."
  }
],

"services": [
  {
    "name": "Kia Carens Rental Pune",
    "description": "Rent the versatile Kia Carens in Pune for any occasion, whether it’s daily city commuting or longer trips. The Carens offers spacious interiors, advanced safety features, and a comfortable ride, making it a popular choice for families and groups seeking reliability and style in their travel."
  },
  {
    "name": "Kia Carens for Outstation Pune",
    "description": "Plan your outstation trips with the Kia Carens rental service in Pune, ideal for comfortable long-distance journeys. With ample legroom and luggage space, this vehicle ensures a smooth and enjoyable ride for all passengers during your travels outside the city limits."
  },
  {
    "name": "Hire Kia Carens in Pune",
    "description": "Easily hire a Kia Carens in Pune with flexible rental plans tailored to your needs. Whether it’s for business, family outings, or special events, the Kia Carens combines elegance with practicality, making your travel hassle-free and enjoyable."
  },
  {
    "name": "Kia Carens 6 Seater Car Pune",
    "description": "The Kia Carens 6 seater offers perfect seating capacity for medium-sized groups or families. Ideal for comfortable city drives or weekend trips, this spacious vehicle provides ample comfort, ensuring every passenger enjoys the ride."
  },
  {
    "name": "Kia Carens for Wedding in Pune",
    "description": "Make your wedding events in Pune extra special with Kia Carens rental service. The car’s elegant design and spacious interiors provide a perfect transport option for the bride, groom, or guests, adding style and convenience to your celebration."
  },
  {
    "name": "Kia Carens Taxi Service Pune",
    "description": "Avail professional Kia Carens taxi services in Pune for reliable and comfortable travel. Experienced drivers and well-maintained vehicles ensure punctual pickups and a smooth journey, whether for daily commutes or special trips."
  },
  {
    "name": "Pune to Mumbai Kia Carens",
    "description": "Travel comfortably from Pune to Mumbai with Kia Carens rental service. Spacious seating, air conditioning, and smooth ride quality make this a preferred choice for business travelers and families alike on this busy route."
  },
  {
    "name": "Kia Carens with Driver Pune",
    "description": "Hire Kia Carens in Pune with professional drivers to enjoy stress-free travel. Experienced chauffeurs ensure safe and timely trips, allowing you to relax or focus on work during your journey."
  },
  {
    "name": "Kia Carens on Rent in Hinjewadi",
    "description": "Easily rent a Kia Carens in the Hinjewadi area of Pune, perfect for IT professionals and families alike. Flexible rental plans and prompt service cater to your travel needs within and outside the locality."
  },
  {
    "name": "Kia Carens for Family Trip Pune",
    "description": "Plan your family trips with the spacious and comfortable Kia Carens in Pune. Its ample seating and luggage capacity make it perfect for weekend getaways, picnics, and long drives with loved ones."
  },
  {
    "name": "Kia Carens for Pune to Goa",
    "description": "Book Kia Carens for the Pune to Goa route for a relaxing and enjoyable vacation. The vehicle’s comfort and space ensure a pleasant travel experience along this popular holiday stretch."
  },
  {
    "name": "Pune to Mahabaleshwar Kia Carens Rental",
    "description": "Rent a Kia Carens for your Pune to Mahabaleshwar trip and enjoy a comfortable journey to this beautiful hill station. The vehicle handles scenic drives with ease, making it an excellent choice for groups and families."
  },
  {
    "name": "Affordable Kia Carens Pune",
    "description": "Get affordable Kia Carens rental options in Pune without compromising on quality or service. Competitive pricing and well-maintained vehicles ensure you get the best value for your travel needs."
  },
  {
    "name": "Kia Carens Booking in Viman Nagar",
    "description": "Conveniently book Kia Carens rentals in the Viman Nagar area of Pune with easy online or phone booking options. Quick service and flexible plans make your travel arrangements hassle-free."
  },
  {
    "name": "Pune Kia Carens Tour Cab",
    "description": "Explore Pune and nearby attractions with Kia Carens tour cab services, offering comfortable rides and professional drivers. Ideal for sightseeing tours, corporate outings, and leisure travel with family or friends."
  }
],
"tableData": [
  ["Kia Carens Rental Pune", "Kia Carens for Outstation Pune"],
  ["Hire Kia Carens in Pune", "Kia Carens 6 Seater Car Pune"],
  ["Kia Carens for Wedding in Pune", "Kia Carens Taxi Service Pune"],
  ["Pune to Mumbai Kia Carens", "Kia Carens with Driver Pune"],
  ["Kia Carens on Rent in Hinjewadi", "Kia Carens for Family Trip Pune"],
  ["Kia Carens for Pune to Goa", "Pune to Mahabaleshwar Kia Carens Rental"],
  ["Affordable Kia Carens Pune", "Kia Carens Booking in Viman Nagar"],
  ["Pune Kia Carens Tour Cab"]
],


"whychoose": [
  {
    "WhyChooseheading": "Spacious and Stylish Kia Carens for Rent in Pune",
    "WhyChoosedescription": "Prince Cabs offers the modern and stylish Kia Carens for rent in Pune, perfect for families, groups, or corporate travel. The Kia Carens is known for its spacious interiors, ergonomic design, and premium comfort, making it an ideal choice for both city rides and outstation journeys. Renting this vehicle ensures you enjoy a luxurious and smooth travel experience with ample legroom and seating for up to 7 passengers."
  },
  {
    "WhyChooseheading": "Competitive and Transparent Rental Pricing",
    "WhyChoosedescription": "Our rental pricing for the Kia Carens in Pune is competitive and completely transparent, including fuel, tolls, driver allowances, and applicable taxes. We believe in no hidden fees, allowing you to budget your trip effectively without any surprises. Whether you choose hourly rentals, one-way trips, or longer bookings, our clear pricing structure ensures excellent value for your money."
  },
  {
    "WhyChooseheading": "Flexible Booking Options Tailored to Your Needs",
    "WhyChoosedescription": "Prince Cabs provides flexible booking options for the Kia Carens, allowing you to choose from hourly, daily, or long-distance rentals. You can easily book through phone, WhatsApp, or online platforms, with instant confirmation and the ability to modify or cancel your booking as per your convenience. Our flexible policies ensure that your travel plans can adapt to your changing requirements seamlessly."
  },
  {
    "WhyChooseheading": "Well-Maintained and Sanitized Vehicles for Your Safety",
    "WhyChoosedescription": "We prioritize your safety and comfort by maintaining our Kia Carens vehicles in excellent condition with regular servicing and thorough sanitization before every trip. Our vehicles come equipped with essential safety features like airbags and seat belts, ensuring a secure journey for you and your passengers. Cleanliness and hygiene are part of our commitment to delivering a worry-free rental experience."
  },
  {
    "WhyChooseheading": "Experienced and Professional Drivers",
    "WhyChoosedescription": "Our skilled drivers are experienced, courteous, and familiar with Pune’s roads and traffic patterns. They ensure smooth, safe, and timely travel while maintaining professionalism throughout your journey. Whether you need airport transfers, city tours, or long-distance travel, our drivers provide reliable service that enhances your overall rental experience."
  },
  {
    "WhyChooseheading": "Ideal for Family and Group Travel",
    "WhyChoosedescription": "The Kia Carens is perfect for families and groups looking to travel together comfortably without compromising on space or convenience. With its ample seating and luggage capacity, it offers the ideal balance of comfort and functionality, making every trip enjoyable and stress-free for everyone on board."
  },
  {
    "WhyChooseheading": "24/7 Customer Support for Hassle-Free Rentals",
    "WhyChoosedescription": "Our dedicated customer support team is available 24/7 to assist with bookings, queries, itinerary changes, and any other travel-related assistance. We strive to provide prompt and friendly service to ensure your Kia Carens rental experience in Pune is smooth and satisfying from start to finish."
  }
]























    }

const faqData = [
    {
        question: 'Can I rent a Kia Carens in Pune with Prince Cabs?',
        answer: 'Yes, Prince Cabs offers Kia Carens on rent in Pune, perfect for comfortable family trips and group travel.',
    },
    {
        question: 'What are the features of the Kia Carens available for rent?',
        answer: 'The Kia Carens we provide comes with spacious seating, modern amenities, and excellent fuel efficiency for a smooth ride.',
    },
    {
        question: 'Is the Kia Carens available for both local and outstation trips from Pune?',
        answer: 'Absolutely! You can rent the Kia Carens for local city travel or longer outstation journeys from Pune.',
    },
    {
        question: 'Are Kia Carens rental cars sanitized and well-maintained?',
        answer: 'Yes, all Kia Carens vehicles are regularly sanitized and serviced to ensure your safety and comfort.',
    },
    {
        question: 'Can I hire a Kia Carens with a driver in Pune?',
        answer: 'Yes, Prince Cabs provides professional drivers with Kia Carens rentals for a hassle-free experience.',
    },
    {
        question: 'What is the rental cost for Kia Carens in Pune?',
        answer: 'Rental charges depend on trip duration and distance. Contact Prince Cabs for a customized and competitive quote.',
    },
    {
        question: 'How do I book a Kia Carens on rent in Pune?',
        answer: 'Booking is easy via our website or by calling our customer support with your travel details.',
    },
];

const testimonials = [
    {
        name: "Mr. Amit Kulkarni",
        position: "Family Traveler",
        text: "Renting the Kia Carens from Prince Cabs in Pune was a great experience. The car was comfortable and the service excellent.",
        image: "/img/testimonial/testimonial-thumb-pune-kia-carens-1.png",
    },
    {
        name: "Ms. Sneha Deshmukh",
        position: "Group Traveler",
        text: "Prince Cabs provided a well-maintained Kia Carens with a courteous driver. Our trip around Pune was smooth and enjoyable.",
        image: "/img/testimonial/testimonial-thumb-pune-kia-carens-2.png",
    },
];






































    const contactData = {
        heading: `${cardData.keyword} Contact Number`,
        contactNumbers: [
            "+91 9284304420",
            "+91 8308844163",


        ],
        email: "booking@princecab.com"
    };


    const Images = [
  { place: "/images/keyword/1.jpg",  text: "Innova Cab on Rent in Hadapsar Pune",            link: "innova-cab-on-rent-in-hadapsar-pune" },
  { place: "/images/keyword/2.jpg",  text: "Pune To Mahabaleshwar Innova Cab",                link: "pune-to-mahabaleshwar-innova-cab" },
  { place: "/images/keyword/3.jpg",  text: "Pune to Shirdi Innova Cab Booking",               link: "pune-to-shirdi-innova-cab-booking" },
  { place: "/images/keyword/4.jpg",  text: "Pune to Mumbai Airport Innova Cab",               link: "pune-to-mumbai-airport-innova-cab" },
  { place: "/images/keyword/5.jpg",  text: "Pune to Goa Innova Cab",                          link: "pune-to-goa-innova-cab" },
  { place: "/images/keyword/6.jpg",  text: "Pune to Ashtavinayak Innova Tour Package",        link: "pune-to-ashtavinayak-innova-tour-package" },
  { place: "/images/keyword/7.jpg",  text: "Sedan Cab Service in Pune",                       link: "sedan-cab-service-in-pune" },
  { place: "/images/keyword/8.jpg",  text: "Etios Cab for Outstation in Pune",                link: "etios-cab-for-outstation-in-pune" },
  { place: "/images/keyword/9.jpg",  text: "Toyota Etios Cab Booking in Pune",                link: "toyota-etios-cab-booking-in-pune" },
  { place: "/images/keyword/10.jpg", text: "Swift Dzire On Rent Pune",                        link: "swift-dzire-on-rent-pune" },
  { place: "/images/keyword/11.jpg", text: "Pune to Shirdi Swift Dzire Cab",                  link: "pune-to-shirdi-swift-dzire-cab" },
  { place: "/images/keyword/12.jpg", text: "Pune to Mahabaleshwar Swift Dzire Cabs",          link: "pune-to-mahabaleshwar-swift-dzire-cabs" },
  { place: "/images/keyword/13.jpg", text: "Pune to Mumbai Dzire Cab",                        link: "pune-to-mumbai-dzire-cab" },
  { place: "/images/keyword/14.jpg", text: "Pune to Gujarat Cab",                             link: "pune-to-gujarat-cab" },
  { place: "/images/keyword/15.jpg", text: "Pune to Rajasthan Cab",                           link: "pune-to-rajasthan-cab" },
  { place: "/images/keyword/16.jpg", text: "Pune to Indore Cab Booking",                      link: "pune-to-indore-cab-booking" },
  { place: "/images/keyword/17.jpg", text: "Pune to Vijayawada Cabs",                         link: "pune-to-vijayawada-cabs" },
  { place: "/images/keyword/18.jpg", text: "Pune to Bangalore Cab",                           link: "pune-to-bangalore-cab" },
  { place: "/images/keyword/19.jpg", text: "Pune to Hyderabad Cab",                           link: "pune-to-hyderabad-cab" },
  { place: "/images/keyword/20.jpg", text: "Pune to Belgaum Cab",                             link: "pune-to-belgaum-cab" },
  { place: "/images/keyword/21.jpg", text: "Pune to Mahabaleshwar Cab",                       link: "pune-to-mahabaleshwar-cab" },
  { place: "/images/keyword/22.jpg", text: "Pune to Panchgani Cab",                           link: "pune-to-panchgani-cab" },
  { place: "/images/keyword/23.jpg", text: "Pune to Goa Cab",                                 link: "pune-to-goa-cab" },
  { place: "/images/keyword/24.jpg", text: "Pune to Bhimashankar Cab",                        link: "pune-to-bhimashankar-cab" },
  { place: "/images/keyword/25.jpg", text: "Pune to Shirdi Cab",                              link: "pune-to-shirdi-cab" },
];




    const images = [
        { src: "/images/gallery/1.jpg", alt: "Image 1" },
        { src: "/images/gallery/5.jpg", alt: "Image 1" },
        { src: "/images/gallery/2.jpg", alt: "Image 1" },
        { src: "/images/gallery/3.jpg", alt: "Image 1" },
        { src: "/images/gallery/4.jpg", alt: "Image 1" },
        { src: "/images/gallery/6.jpg", alt: "Image 1" },

    ];




const productSchema = {
  "@context": "https://schema.org",
  "@type": "Service",
  "name": "Kia Carens On Rent in Pune",
  "description": "Kia Carens on rent in Pune for outstation trips, weddings, family tours, and city travel. 6-seater Kia Carens available with driver. Book from Hinjewadi, Viman Nagar, and across Pune.",
  "provider": {
    "@type": "LocalBusiness",
    "name": "Prince Cabs",
    "telephone": "+91-XXXXXXXXXX",
    "address": {
      "@type": "PostalAddress",
      "addressLocality": "Pune",
      "addressRegion": "Maharashtra",
      "addressCountry": "IN"
    }
  },
  "serviceType": [
    "Kia Carens Rental Pune",
    "Kia Carens for Outstation Pune",
    "Hire Kia Carens in Pune",
    "Kia Carens 6 Seater Car Pune",
    "Kia Carens for Wedding in Pune",
    "Kia Carens Taxi Service Pune",
    "Pune to Mumbai Kia Carens",
    "Kia Carens with Driver Pune",
    "Kia Carens on Rent in Hinjewadi",
    "Kia Carens for Family Trip Pune",
    "Kia Carens for Pune to Goa",
    "Pune to Mahabaleshwar Kia Carens Rental",
    "Affordable Kia Carens Pune",
    "Kia Carens Booking in Viman Nagar",
    "Pune Kia Carens Tour Cab"
  ],
  "areaServed": {
    "@type": "City",
    "name": "Pune"
  }
};




    return (
        <div>
<Helmet>
  <title>Kia Carens on Rent in Pune | 6-Seater Outstation & City Rental</title>
  <meta
    name="description"
    content="Book Kia Carens in Pune for outstation trips, weddings, family tours or Pune to Goa and Mumbai routes. Available in Hinjewadi, Viman Nagar, and all areas of Pune."
  />
  <meta
    name="keywords"
    content="Kia Carens Rental Pune, Kia Carens for Outstation Pune, Hire Kia Carens in Pune, Kia Carens 6 Seater Car Pune, Kia Carens for Wedding in Pune, Kia Carens Taxi Service Pune, Pune to Mumbai Kia Carens, Kia Carens with Driver Pune, Kia Carens on Rent in Hinjewadi, Kia Carens for Family Trip Pune, Kia Carens for Pune to Goa, Pune to Mahabaleshwar Kia Carens Rental, Affordable Kia Carens Pune, Kia Carens Booking in Viman Nagar, Pune Kia Carens Tour Cab"
  />
  <script type="application/ld+json">
    {JSON.stringify(productSchema)}
  </script>
</Helmet>

            <section className="inner-banner-wrap">
                <div
                    className="inner-baner-container"
                    style={{ backgroundImage: 'url(/images/inner-banner.jpg)' }}
                >
                    <div className="container">
                        <div className="inner-banner-content">
                            <h1 className="inner-title">{cardData.keyword} </h1>
                        </div>
                    </div>
                </div>
                <div className="inner-shape"></div>
            </section>







            <section>
                <div className="container-fluid" >
                    <div className="row container-fluid">
                        <div className="col-12 col-md-7 bg-foootr">
                            <img src='/images/keyword/59.jpg' alt='img' />
                            <h3 className="py-1"
                                style={{
                                    color: '#AF3125', // Red color for the title 
                                    textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                                    fontWeight: 'bold'
                                }}


                            >{cardData.heading} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
                             <div className="topPlaces">
  <p className="sectionLead">{cardData.top}</p>

  {cardData.topPlaces.map((place, index) => (
    <article key={index} className="placeCard" tabIndex="0">
      <span className="placeBadge">{String(index + 1).padStart(2, "0")}</span>

      <div className="placeBody">
        <h4 className="placeTitle">{place.title}</h4>
        <p className="placeDesc">{place.description}</p>
      </div>

      <span className="placeArrow" aria-hidden>›</span>
    </article>
  ))}
</div>
                            <div
                                style={{
                                    cursor: 'pointer',
                                    padding: '10px',
                                    marginBottom: '7px',
                                    borderRadius: '8px', // Optional: rounded corners
                                    transition: 'transform 0.2s' // Optional: smooth scaling effect
                                }}
                            >
                                {cardData.services.map((service, index) => (
                                    <div key={index} className=" my-4">
                                        <h4 className="py-1 darkcolorrr">{service.name}</h4>
                                        <p>{service.description}</p>
                                    </div>
                                ))}
                            </div>

                            <table className="table table-responsive Border-key my-2">
                                <tbody className=' Border-key'>
                                    {cardData.tableData.map((row, rowIndex) => (
                                        <tr className='Border-key ' key={rowIndex}>
                                            {row.map((cell, cellIndex) => (
                                                <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                                            ))}
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                            <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
                            <BusRatesTable />

                            <div id="why-choose-section"
                                className='px-2 bg-foootr'>
                                {cardData.whychoose.map((item, index) => (
                                    <div key={index}>
                                        <h4 className="py-1 whycolor">{item.WhyChooseheading}</h4>
                                        <p>{item.WhyChoosedescription}</p>
                                    </div>
                                ))}
                            </div>


                            <div className="row twm-faq-section-1 m-b30">


                                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                                    <div className="twm-faq-info-wrap">

                                        <div className="section-head left">
                                            <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For Vihaan Travels </h2>
                                        </div>


                                        <div className="twm-faq-info">
                                            <div className="accordion twm-acdn" id="sf-faq-accordion">

                                                <FaqSection
                                                    title="Frequently Asked"
                                                    subtitle="Help & Info"
                                                    items={faqData}
                                                />

                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>


                            <TestimonialSection testimonials={testimonials} />


 <ContactShowcase/>
                        </div>

                        <div className='col-12 col-md-4' >
                            <div className="routeList">
  {Images.map((e, i) => {
    const isExternal = typeof e.link === "string" && /^https?:\/\//i.test(e.link);
    const href = isExternal ? e.link : `/${String(e.link || "").replace(/^\/+/, "")}`;

    return (
      <a
        key={e.link || i}
        href={href}
        className="routeItem"
        aria-label={e.text}
        {...(isExternal ? { target: "_blank", rel: "noopener noreferrer" } : {})}
      >
        <div className="routeThumb">
          <img src={e.place} alt="" loading="lazy" />
        </div>

        <div className="routeMeta">
          <h6 className="routeTitle">{e.text}</h6>
          <span className="routeUnderline" />
        </div>

        <span className="routeArrow" aria-hidden>›</span>
      </a>
    );
  })}
</div>



                            {/* <div className="gallery-container">
                                <h2 className="gallery-title">Our Fleets</h2>
                                <div className="gallery-row d-flex flex-wrap">
                                    {images.map((image, index) => (
                                        <div className="gallery-item col-md-4" key={index}>
                                            <img
                                                src={image.src}
                                                alt={image.alt}
                                                className="gallery-image"

                                            />
                                        </div>
                                    ))}

                                </div>
                        </div> */}
<div>
  <FleetHighway/>
</div>
                            <div className="pc-contact">
  <h4 className="pc-title">Contact Information</h4>

  <div className="pc-grid">
    {/* Phones */}
    <section className="pc-tile">
      <header className="pc-tile-head">
        <i className="bi bi-telephone-fill"></i>
        <span>Phone Numbers</span>
      </header>

      <div className="pc-list">
        <a href="tel:+919284304420" className="pc-call">+91 9284304420</a>
        <a href="tel:+918308844163" className="pc-call">+91 8308844163</a>
      </div>

      <div className="pc-cta">
        <a
          href="https://wa.me/919284304420"
          target="_blank" rel="noopener noreferrer"
          className="pc-whats"
        >
          <i className="bi bi-whatsapp me-1"></i> WhatsApp
        </a>
        <a href="tel:+919284304420" className="pc-primary">
          Call Now
        </a>
      </div>
    </section>

    {/* Email */}
    <section className="pc-tile">
      <header className="pc-tile-head">
        <i className="bi bi-envelope-fill"></i>
        <span>Email</span>
      </header>

      <a href="mailto:booking@princecab.com" className="pc-email">
        booking@princecab.com
      </a>
    </section>

    {/* Address */}
    <section className="pc-tile">
      <header className="pc-tile-head">
        <i className="bi bi-house-fill"></i>
        <span>Address</span>
      </header>

      <address className="pc-address">
        <strong>Prince Cabs</strong><br />
        Office No 106, 2nd Floor, Nilgiri Nest Co-op Housing Society,<br />
        Pimple Gurav, Pune, Pin - 411027
      </address>
    </section>
  </div>
</div>



                        </div>
                    </div>
                </div>
            </section>


        </div>
    );
}

export default Kiacarenceonrentinpune ;